// Centralized mock dataset — Bengaluru-first real estate advisory data.
const IMG = {
  apt1: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1400&q=80",
  apt2: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1400&q=80",
  apt3: "https://images.unsplash.com/photo-1523217582562-09d0def993a6?auto=format&fit=crop&w=1400&q=80",
  apt4: "https://images.unsplash.com/photo-1515263487990-61b07816b324?auto=format&fit=crop&w=1400&q=80",
  villa1: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
  villa2: "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?auto=format&fit=crop&w=1400&q=80",
  villa3: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=1400&q=80",
  villa4: "https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?auto=format&fit=crop&w=1400&q=80",
  int1: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1400&q=80",
  int2: "https://images.unsplash.com/photo-1658218635253-64728f6234be?auto=format&fit=crop&w=1400&q=80",
  int3: "https://images.unsplash.com/photo-1713832139688-79676097edde?auto=format&fit=crop&w=1400&q=80",
  int4: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=80",
  comm1: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1400&q=80",
  comm2: "https://images.unsplash.com/photo-1775733924258-5363323b3ab8?auto=format&fit=crop&w=1400&q=80",
  luxeHero: "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?auto=format&fit=crop&w=1600&q=80",
  hero: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
  tileLiving: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=80",
  tileInvests: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80",
  tileLuxe: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=1200&q=80",
  penthouse: "https://images.unsplash.com/photo-1600573472591-ee6b68d14c68?auto=format&fit=crop&w=1400&q=80",
  living: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1400&q=80",
};

export const IMAGES = IMG;

const now = Date.now();
const day = 86400000;
const iso = (offsetDays) => new Date(now + offsetDays * day).toISOString();

export const MICRO_MARKETS = [
  "Whitefield", "Sarjapur Road", "Varthur", "Bellandur", "HSR Layout",
  "Budigere Cross", "Hebbal", "Thanisandra", "Yelahanka", "Devanahalli",
  "Electronic City", "Kanakapura Road", "Bannerghatta Road",
];

export const PROPERTY_TYPES = ["Apartment", "Villa", "Plot", "Commercial", "Penthouse"];
export const CONFIGS = ["2 BHK", "3 BHK", "3.5 BHK", "4 BHK", "5 BHK", "Villa", "Plot"];
export const STAGES = ["Pre-Launch", "Under Construction", "Nearing Completion", "Ready to Move"];
export const ADVISORS = ["Aarav Menon", "Isha Rao", "Kabir Nair", "Meera Iyer"];
export const SOURCES = ["Website", "Referral", "Walk-in", "Campaign", "Partner"];

export const properties = [
  {
    id: "p1",
    project: "Aster Meridian",
    developer: "Prestige Group",
    category: ["living", "invests"],
    propertyType: "Apartment",
    location: "Whitefield",
    microMarket: "Whitefield",
    priceMin: 12500000, priceMax: 21000000,
    area: "1,250 – 1,980 sq.ft",
    configuration: ["2 BHK", "3 BHK"],
    possession: "Dec 2026",
    constructionStage: "Under Construction",
    rera: "PRM/KA/RERA/1251/446/PR/010324/006712",
    published: true, featured: true, createdAt: iso(-40),
    description:
      "A calm, well-planned residential address in the heart of Whitefield's established tech corridor, designed for families who value connectivity without compromise.",
    amenities: ["Clubhouse", "Lap Pool", "Gymnasium", "Landscaped Gardens", "Kids' Play", "Co-working Lounge", "24x7 Security"],
    features: ["Vitrified flooring", "Modular kitchen provision", "3-tier security", "Rainwater harvesting"],
    locationHighlights: ["8 min to ITPL", "Metro Purple Line access", "Reputed schools within 3 km", "Multiple healthcare options"],
    developerDetails: "Prestige Group — among South India's most established developers with a strong delivery track record.",
    images: [IMG.apt1, IMG.int1, IMG.comm2],
    scores: { lifestyleFit: 82, commute: 76, connectivity: 84, space: 70, community: 78, education: 80, amenities: 85, longTerm: 79, entry: 74, microMarket: 86, demand: 82, rental: 80, infrastructure: 84, developer: 90, exit: 78 },
    whyStandout: "A mature micro-market with proven rental depth and consistent end-user demand — rare for a project still under construction.",
    whoSuits: "Working professionals and young families anchored to the Whitefield / ITPL employment belt.",
    whatConsider: "Under-construction timeline means possession is 2026 — align this with your move-in or holding horizon.",
    internalNotes: "Developer offering 10:90 plan for Q2 bookings.",
  },
  {
    id: "p2",
    project: "Verdant Sanctuary",
    developer: "Total Environment",
    category: ["living"],
    propertyType: "Apartment",
    location: "Sarjapur Road",
    microMarket: "Sarjapur Road",
    priceMin: 16800000, priceMax: 28500000,
    area: "1,650 – 2,540 sq.ft",
    configuration: ["3 BHK", "3.5 BHK"],
    possession: "Ready to Move",
    constructionStage: "Ready to Move",
    rera: "PRM/KA/RERA/1251/309/PR/180722/005011",
    published: true, featured: true, createdAt: iso(-25),
    description:
      "Biophilic architecture with generous green terraces — a lifestyle-led home for those who want nature woven into everyday living.",
    amenities: ["Terrace Gardens", "Infinity Pool", "Yoga Deck", "Amphitheatre", "Pet Park", "Library Lounge"],
    features: ["Floor-to-ceiling glazing", "Private planter terraces", "Home automation ready"],
    locationHighlights: ["Near Sarjapur tech parks", "Proposed Metro corridor", "International schools nearby"],
    developerDetails: "Total Environment — known for design-forward, nature-integrated homes.",
    images: [IMG.apt3, IMG.int3, IMG.living],
    scores: { lifestyleFit: 90, commute: 68, connectivity: 72, space: 88, community: 84, education: 86, amenities: 88, longTerm: 85, entry: 66, microMarket: 78, demand: 76, rental: 72, infrastructure: 74, developer: 84, exit: 70 },
    whyStandout: "One of the few ready-to-move, design-led communities on Sarjapur Road with mature landscaping already in place.",
    whoSuits: "Lifestyle-driven families who prioritise space, greenery and community over pure price.",
    whatConsider: "Peak-hour connectivity on Sarjapur Road remains a work in progress until the metro extension lands.",
    internalNotes: "Only 6 units of 3.5 BHK remaining.",
  },
  {
    id: "p3",
    project: "Skyline Vantage",
    developer: "Brigade Group",
    category: ["invests", "living"],
    propertyType: "Apartment",
    location: "Hebbal",
    microMarket: "Hebbal",
    priceMin: 14200000, priceMax: 24000000,
    area: "1,320 – 2,100 sq.ft",
    configuration: ["2 BHK", "3 BHK"],
    possession: "Jun 2027",
    constructionStage: "Nearing Completion",
    rera: "PRM/KA/RERA/1250/303/PR/090823/006120",
    published: true, featured: false, createdAt: iso(-18),
    description:
      "A high-rise vantage over Hebbal's lake and outer ring road — positioned at the intersection of the airport corridor and the northern business district.",
    amenities: ["Sky Lounge", "Business Centre", "Pool", "Gym", "Retail Boulevard"],
    features: ["Double-glazed windows", "EV charging", "Smart access"],
    locationHighlights: ["Airport corridor", "ORR employment hub", "Manyata Tech Park proximity"],
    developerDetails: "Brigade Group — large-format developer with strong commercial adjacencies.",
    images: [IMG.apt2, IMG.int2, IMG.comm1],
    scores: { lifestyleFit: 74, commute: 82, connectivity: 88, space: 68, community: 72, education: 70, amenities: 78, longTerm: 80, entry: 80, microMarket: 88, demand: 86, rental: 88, infrastructure: 90, developer: 86, exit: 84 },
    whyStandout: "Airport-corridor positioning with strong rental catchment from Manyata and the northern IT belt.",
    whoSuits: "Investors seeking rental depth and appreciation tied to infrastructure momentum.",
    whatConsider: "Northern corridor traffic can be heavy — evaluate the specific tower and floor for the view premium.",
    internalNotes: "High investor interest; corner units command premium.",
  },
  {
    id: "p4",
    project: "The Devanahalli Reserve",
    developer: "Embassy Group",
    category: ["invests"],
    propertyType: "Plot",
    location: "Devanahalli",
    microMarket: "Devanahalli",
    priceMin: 9500000, priceMax: 18000000,
    area: "1,200 – 2,400 sq.ft plots",
    configuration: ["Plot"],
    possession: "Ready to Register",
    constructionStage: "Ready to Move",
    rera: "PRM/KA/RERA/1252/446/PR/210623/005980",
    published: true, featured: false, createdAt: iso(-12),
    description:
      "A gated plotted development near the airport growth node, engineered for capital appreciation as North Bengaluru's infrastructure matures.",
    amenities: ["Gated Entry", "Underground Utilities", "Avenue Plantation", "Clubhouse Provision"],
    features: ["Clear title", "BIAAPA approved", "Wide internal roads"],
    locationHighlights: ["Near KIA airport", "Aerospace SEZ", "Proposed business park"],
    developerDetails: "Embassy Group — major North Bengaluru land and commercial developer.",
    images: [IMG.comm1, IMG.villa3, IMG.comm2],
    scores: { entry: 88, microMarket: 84, demand: 70, rental: 52, infrastructure: 86, developer: 88, exit: 76, lifestyleFit: 58, commute: 60, connectivity: 74, space: 90, community: 60, education: 56, amenities: 60, longTerm: 82 },
    whyStandout: "Early-stage entry pricing in a corridor with clear, funded infrastructure catalysts.",
    whoSuits: "Patient investors with a 5–8 year horizon comfortable with plotted assets.",
    whatConsider: "Plots generate no rental income during the holding period — this is an appreciation play.",
    internalNotes: "Best margin product in current inventory.",
  },
  {
    id: "p5",
    project: "Aria Hillcrest",
    developer: "Sobha Limited",
    category: ["luxe", "living"],
    propertyType: "Villa",
    location: "Kanakapura Road",
    microMarket: "Kanakapura Road",
    priceMin: 42000000, priceMax: 68000000,
    area: "3,800 – 5,600 sq.ft",
    configuration: ["4 BHK", "5 BHK", "Villa"],
    possession: "Mar 2027",
    constructionStage: "Under Construction",
    rera: "PRM/KA/RERA/1251/472/PR/150823/006301",
    published: true, featured: true, createdAt: iso(-30),
    description:
      "A limited collection of hillside villas with expansive private grounds, where architecture and landscape are designed as one continuous experience.",
    amenities: ["Private Pools", "Concierge", "Wine Cellars", "Home Theatre", "Wellness Spa", "Golf Putting Green"],
    features: ["Double-height living", "Imported fittings", "Private lift", "Landscaped decks"],
    locationHighlights: ["Green belt setting", "Low-density enclave", "Metro extension planned"],
    developerDetails: "Sobha Limited — backward-integrated developer renowned for build quality.",
    images: [IMG.villa1, IMG.penthouse, IMG.villa4],
    scores: { privacy: 92, scarcity: 88, architecture: 90, spaceLuxe: 94, location: 78, pedigree: 90, lifestyleFit: 88, commute: 62, connectivity: 66, space: 95, community: 74, education: 72, amenities: 90, longTerm: 86 },
    whyStandout: "Genuine low-density living with private grounds — increasingly scarce within the city's green belt.",
    whoSuits: "Buyers seeking privacy, scale and a considered architectural statement.",
    whatConsider: "The green-belt location trades some connectivity for exclusivity and calm.",
    internalNotes: "Only 22 villas in the phase; 9 sold.",
  },
  {
    id: "p6",
    project: "Cirro Private Residences",
    developer: "Phoenix Mills",
    category: ["luxe"],
    propertyType: "Penthouse",
    location: "Bellandur",
    microMarket: "Bellandur",
    priceMin: 55000000, priceMax: 120000000,
    area: "4,200 – 7,800 sq.ft",
    configuration: ["4 BHK", "5 BHK", "Penthouse"],
    possession: "Sep 2027",
    constructionStage: "Under Construction",
    rera: "PRM/KA/RERA/1250/304/PR/260823/006455",
    published: true, featured: true, createdAt: iso(-8),
    description:
      "Sky residences above the city's lakefront, with private elevators, curated interiors and a level of service more often found in a grand hotel.",
    amenities: ["Private Elevator", "Sky Deck", "Butler Service", "Cigar Lounge", "Infinity Edge Pool", "Private Dining"],
    features: ["Panoramic glazing", "Smart climate control", "Bespoke joinery"],
    locationHighlights: ["Lakefront views", "ORR tech corridor", "Luxury retail adjacency"],
    developerDetails: "Phoenix Mills — premium mixed-use and luxury developer.",
    images: [IMG.penthouse, IMG.int4, IMG.villa2],
    scores: { privacy: 90, scarcity: 94, architecture: 92, spaceLuxe: 90, location: 84, pedigree: 86, lifestyleFit: 84, commute: 70, connectivity: 80, space: 88, community: 70, education: 64, amenities: 92, longTerm: 82 },
    whyStandout: "Lakefront sky residences with hotel-grade service — a genuinely scarce proposition in the ORR belt.",
    whoSuits: "Discerning buyers for whom privacy, view and service define value.",
    whatConsider: "Premium maintenance and service charges reflect the bespoke offering.",
    internalNotes: "Ultra-premium; qualify clients before viewing.",
  },
  {
    id: "p7",
    project: "Metro Junction Heights",
    developer: "Puravankara",
    category: ["invests", "living"],
    propertyType: "Apartment",
    location: "Electronic City",
    microMarket: "Electronic City",
    priceMin: 8200000, priceMax: 13500000,
    area: "980 – 1,480 sq.ft",
    configuration: ["2 BHK", "3 BHK"],
    possession: "Ready to Move",
    constructionStage: "Ready to Move",
    rera: "PRM/KA/RERA/1251/310/PR/120522/004890",
    published: true, featured: false, createdAt: iso(-50),
    description:
      "An efficiently designed, well-priced community steps from the Electronic City metro — built for strong rental yield and entry-level end-users.",
    amenities: ["Pool", "Gym", "Community Hall", "Jogging Track", "Retail"],
    features: ["Compact efficient layouts", "Piped gas", "Solar common areas"],
    locationHighlights: ["Metro Yellow Line", "Infosys / Wipro proximity", "NICE road access"],
    developerDetails: "Puravankara — high-volume developer with wide product range.",
    images: [IMG.apt4, IMG.int2, IMG.comm2],
    scores: { entry: 86, microMarket: 78, demand: 84, rental: 90, infrastructure: 80, developer: 78, exit: 80, lifestyleFit: 70, commute: 84, connectivity: 82, space: 62, community: 70, education: 66, amenities: 70, longTerm: 72 },
    whyStandout: "Metro-adjacent, ready inventory with one of the strongest rental yields in current supply.",
    whoSuits: "Yield-focused investors and first-time end-users in the tech south.",
    whatConsider: "Compact layouts prioritise efficiency over generous space.",
    internalNotes: "Strong yield story for NRI investors.",
  },
  {
    id: "p8",
    project: "Thanisandra Grove",
    developer: "Godrej Properties",
    category: ["living", "invests"],
    propertyType: "Apartment",
    location: "Thanisandra",
    microMarket: "Thanisandra",
    priceMin: 11000000, priceMax: 17500000,
    area: "1,150 – 1,720 sq.ft",
    configuration: ["2 BHK", "3 BHK"],
    possession: "Dec 2026",
    constructionStage: "Under Construction",
    rera: "PRM/KA/RERA/1250/305/PR/300723/006090",
    published: true, featured: false, createdAt: iso(-15),
    description:
      "A balanced family address on the northern corridor with easy Manyata access and a strong social infrastructure taking shape around it.",
    amenities: ["Clubhouse", "Pool", "Gym", "Sports Courts", "Kids' Zone", "Senior Deck"],
    features: ["Cross-ventilated design", "Rainwater harvesting", "STP"],
    locationHighlights: ["Manyata Tech Park", "Airport corridor", "Emerging retail"],
    developerDetails: "Godrej Properties — trusted national developer with strong governance.",
    images: [IMG.apt1, IMG.int3, IMG.comm1],
    scores: { lifestyleFit: 78, commute: 78, connectivity: 80, space: 74, community: 78, education: 74, amenities: 80, longTerm: 80, entry: 78, microMarket: 82, demand: 82, rental: 82, infrastructure: 82, developer: 88, exit: 80 },
    whyStandout: "A well-rounded northern-corridor option balancing end-use comfort and investment fundamentals.",
    whoSuits: "Families and investors seeking a dependable, brand-backed choice.",
    whatConsider: "Social infrastructure is still maturing in parts of Thanisandra.",
    internalNotes: "Balanced product; good for undecided buyers.",
  },
  {
    id: "p9",
    project: "HSR Central One",
    developer: "Assetz Property",
    category: ["living", "luxe"],
    propertyType: "Apartment",
    location: "HSR Layout",
    microMarket: "HSR Layout",
    priceMin: 22000000, priceMax: 38000000,
    area: "1,800 – 2,700 sq.ft",
    configuration: ["3 BHK", "4 BHK"],
    possession: "Ready to Move",
    constructionStage: "Ready to Move",
    rera: "PRM/KA/RERA/1251/311/PR/050622/005210",
    published: true, featured: true, createdAt: iso(-22),
    description:
      "A boutique low-density address in one of Bengaluru's most sought-after neighbourhoods, where walkability and lifestyle meet a genuine scarcity of new supply.",
    amenities: ["Rooftop Lounge", "Pool", "Gym", "Concierge", "EV Charging", "Private Garden"],
    features: ["Large balconies", "Premium fittings", "Low density"],
    locationHighlights: ["HSR social hub", "Startup ecosystem", "Walkable cafés & retail"],
    developerDetails: "Assetz Property — design-led boutique developer.",
    images: [IMG.apt3, IMG.living, IMG.int4],
    scores: { lifestyleFit: 92, commute: 80, connectivity: 84, space: 82, community: 86, education: 80, amenities: 84, longTerm: 88, privacy: 78, scarcity: 88, architecture: 82, spaceLuxe: 82, location: 90, pedigree: 78, entry: 62, microMarket: 84, demand: 80, rental: 74, infrastructure: 82, developer: 80, exit: 82 },
    whyStandout: "New supply in HSR is genuinely scarce — a walkable, lifestyle-first address with lasting demand.",
    whoSuits: "Buyers who want to live inside the city's social fabric, not commute to it.",
    whatConsider: "Premium micro-market pricing reflects the scarcity of new inventory here.",
    internalNotes: "Trophy location; limited stock.",
  },
  {
    id: "p10",
    project: "Budigere Skypark",
    developer: "Mahindra Lifespaces",
    category: ["invests"],
    propertyType: "Apartment",
    location: "Budigere Cross",
    microMarket: "Budigere Cross",
    priceMin: 7600000, priceMax: 12200000,
    area: "1,020 – 1,560 sq.ft",
    configuration: ["2 BHK", "3 BHK"],
    possession: "Jun 2027",
    constructionStage: "Pre-Launch",
    rera: "PRM/KA/RERA/1250/306/PR/010923/006540",
    published: false, featured: false, createdAt: iso(-4),
    description:
      "A pre-launch opportunity on the fast-developing Budigere corridor, positioned to benefit from the airport and Whitefield growth pincer.",
    amenities: ["Clubhouse", "Pool", "Gym", "Co-working", "Amphitheatre"],
    features: ["Efficient layouts", "Green certification target", "Smart metering"],
    locationHighlights: ["Airport & Whitefield pincer", "Upcoming flyover", "New tech parks"],
    developerDetails: "Mahindra Lifespaces — sustainability-focused national developer.",
    images: [IMG.apt2, IMG.int1, IMG.comm2],
    scores: { entry: 90, microMarket: 76, demand: 74, rental: 72, infrastructure: 84, developer: 82, exit: 74, lifestyleFit: 68, commute: 70, connectivity: 72, space: 70, community: 66, education: 62, amenities: 72, longTerm: 78 },
    whyStandout: "Pre-launch entry pricing ahead of the Budigere corridor's infrastructure inflection.",
    whoSuits: "Early investors comfortable with a pre-launch, longer-horizon position.",
    whatConsider: "Pre-launch status carries construction and approval timeline risk.",
    internalNotes: "Not yet published — pending RERA display clearance.",
  },
];

export const team = [
  { id: "t1", name: "Aarav Menon", role: "Founder", email: "aarav@archedia.in", clients: 0, leads: 0 },
  { id: "t2", name: "Isha Rao", role: "Advisor", email: "isha@archedia.in", clients: 0, leads: 0 },
  { id: "t3", name: "Kabir Nair", role: "Relationship Manager", email: "kabir@archedia.in", clients: 0, leads: 0 },
  { id: "t4", name: "Meera Iyer", role: "Operations", email: "meera@archedia.in", clients: 0, leads: 0 },
];

const purposes = ["Living", "Investment", "Luxury", "Exploring"];
const stagesList = ["New", "Contacted", "Qualified", "Curating", "Site Visit", "Negotiation", "Converted"];

export const leads = [
  { id: "ARC-L-0001", createdDate: iso(-14), name: "Rohan Shah", phone: "+91 98450 11223", email: "client@archedia.in", purpose: "Living", propertyType: "Apartment", budget: "₹1.2 – 1.8 Cr", locations: ["Whitefield", "HSR Layout"], configuration: "3 BHK", timeline: "3–6 months", priorities: ["Connectivity", "Schools", "Space"], advisor: "Isha Rao", stage: "Curating", lastActivity: iso(-1), nextFollowUp: iso(2), source: "Website", notes: "Prefers ready-to-move; young family.", activity: [{ date: iso(-14), text: "Requirement submitted via website" }, { date: iso(-12), text: "Advisor Isha Rao assigned" }, { date: iso(-6), text: "Requirement understood — call completed" }, { date: iso(-1), text: "Curated 3 properties" }] },
  { id: "ARC-L-0002", createdDate: iso(-10), name: "Priya Nair", phone: "+91 99010 44556", email: "priya.n@example.com", purpose: "Investment", propertyType: "Apartment", budget: "₹80L – 1.2 Cr", locations: ["Electronic City", "Budigere Cross"], configuration: "2 BHK", timeline: "0–3 months", priorities: ["Rental Potential", "Appreciation Potential"], advisor: "Kabir Nair", stage: "Site Visit", lastActivity: iso(-2), nextFollowUp: iso(-1), source: "Referral", notes: "NRI investor; yield focused.", activity: [{ date: iso(-10), text: "Requirement submitted" }, { date: iso(-9), text: "Advisor Kabir Nair assigned" }, { date: iso(-4), text: "Shortlist shared" }, { date: iso(-2), text: "Site visit scheduled" }] },
  { id: "ARC-L-0003", createdDate: iso(-7), name: "Vikram Reddy", phone: "+91 98800 77889", email: "vikram.r@example.com", purpose: "Luxury", propertyType: "Villa", budget: "₹4 – 7 Cr", locations: ["Kanakapura Road", "Bellandur"], configuration: "4 BHK", timeline: "6–12 months", priorities: ["Low Density", "Developer", "Space"], advisor: "Aarav Menon", stage: "Qualified", lastActivity: iso(-3), nextFollowUp: iso(1), source: "Partner", notes: "Wants privacy and pedigree.", activity: [{ date: iso(-7), text: "Requirement submitted" }, { date: iso(-6), text: "Advisor Aarav Menon assigned" }, { date: iso(-3), text: "Qualified — budget confirmed" }] },
  { id: "ARC-L-0004", createdDate: iso(-5), name: "Sneha Kulkarni", phone: "+91 97400 22110", email: "sneha.k@example.com", purpose: "Living", propertyType: "Apartment", budget: "₹1.5 – 2.5 Cr", locations: ["Sarjapur Road", "HSR Layout"], configuration: "3.5 BHK", timeline: "3–6 months", priorities: ["Lifestyle", "Amenities", "Community"], advisor: "Isha Rao", stage: "Contacted", lastActivity: iso(-1), nextFollowUp: iso(0), source: "Campaign", notes: "Design-conscious buyer.", activity: [{ date: iso(-5), text: "Requirement submitted" }, { date: iso(-4), text: "Advisor Isha Rao assigned" }, { date: iso(-1), text: "First call completed" }] },
  { id: "ARC-L-0005", createdDate: iso(-3), name: "Arjun Pillai", phone: "+91 90080 33445", email: "arjun.p@example.com", purpose: "Investment", propertyType: "Plot", budget: "₹90L – 1.5 Cr", locations: ["Devanahalli"], configuration: "Plot", timeline: "6–12 months", priorities: ["Appreciation Potential", "Developer"], advisor: "Kabir Nair", stage: "New", lastActivity: iso(-3), nextFollowUp: iso(1), source: "Website", notes: "Airport-corridor land interest.", activity: [{ date: iso(-3), text: "Requirement submitted via website" }] },
  { id: "ARC-L-0006", createdDate: iso(-2), name: "Fatima Sheikh", phone: "+91 96110 55667", email: "fatima.s@example.com", purpose: "Exploring", propertyType: "Apartment", budget: "₹1 – 1.5 Cr", locations: ["Hebbal", "Thanisandra"], configuration: "2 BHK", timeline: "Just exploring", priorities: ["Connectivity", "Workplace"], advisor: "Meera Iyer", stage: "New", lastActivity: iso(-2), nextFollowUp: iso(3), source: "Walk-in", notes: "Early stage; needs education.", activity: [{ date: iso(-2), text: "Walk-in enquiry captured" }] },
  { id: "ARC-L-0007", createdDate: iso(-20), name: "Deepak Menon", phone: "+91 98860 99001", email: "deepak.m@example.com", purpose: "Investment", propertyType: "Apartment", budget: "₹1.2 – 1.6 Cr", locations: ["Whitefield"], configuration: "3 BHK", timeline: "0–3 months", priorities: ["Rental Potential", "Developer"], advisor: "Kabir Nair", stage: "Negotiation", lastActivity: iso(-1), nextFollowUp: iso(1), source: "Referral", notes: "Negotiating on Aster Meridian.", activity: [{ date: iso(-20), text: "Requirement submitted" }, { date: iso(-18), text: "Advisor assigned" }, { date: iso(-10), text: "Site visit completed" }, { date: iso(-1), text: "Price negotiation in progress" }] },
  { id: "ARC-L-0008", createdDate: iso(-28), name: "Anita George", phone: "+91 99450 66778", email: "anita.g@example.com", purpose: "Living", propertyType: "Apartment", budget: "₹2 – 3 Cr", locations: ["HSR Layout"], configuration: "4 BHK", timeline: "Done", priorities: ["Lifestyle", "Space"], advisor: "Isha Rao", stage: "Converted", lastActivity: iso(-2), nextFollowUp: null, source: "Website", notes: "Booked HSR Central One.", activity: [{ date: iso(-28), text: "Requirement submitted" }, { date: iso(-25), text: "Advisor assigned" }, { date: iso(-15), text: "Site visit completed" }, { date: iso(-2), text: "Booking confirmed — converted" }] },
];

export const clients = [
  { id: "c1", name: "Rohan Shah", phone: "+91 98450 11223", email: "client@archedia.in", purpose: "Living", budget: "₹1.2 – 1.8 Cr", requirement: "3 BHK, ready-to-move, family-first, Whitefield / HSR", advisor: "Isha Rao", leadId: "ARC-L-0001", recommendedProperties: ["p1", "p9", "p8"], shortlist: ["p1", "p9"], comparisons: [], notes: "Young family, values schools and connectivity.", createdAt: iso(-14), activity: [{ date: iso(-14), text: "Became a client" }, { date: iso(-1), text: "Advisor curated 3 properties" }] },
  { id: "c2", name: "Priya Nair", phone: "+91 99010 44556", email: "priya.n@example.com", purpose: "Investment", budget: "₹80L – 1.2 Cr", requirement: "2 BHK, high yield, tech-south", advisor: "Kabir Nair", leadId: "ARC-L-0002", recommendedProperties: ["p7", "p10"], shortlist: ["p7"], comparisons: [], notes: "NRI, yield focused.", createdAt: iso(-10), activity: [{ date: iso(-10), text: "Became a client" }] },
];

export const interests = [
  { id: "i1", clientName: "Rohan Shah", clientId: "c1", propertyId: "p1", stage: "Qualified", advisor: "Isha Rao", createdAt: iso(-5), notes: "Loved the layout." },
  { id: "i2", clientName: "Deepak Menon", clientId: null, propertyId: "p1", stage: "Negotiation", advisor: "Kabir Nair", createdAt: iso(-9), notes: "Negotiating price." },
  { id: "i3", clientName: "Priya Nair", clientId: "c2", propertyId: "p7", stage: "Site Visit", advisor: "Kabir Nair", createdAt: iso(-4), notes: "Yield discussion done." },
];

export const siteVisits = [
  { id: "sv1", clientName: "Priya Nair", clientId: "c2", propertyId: "p7", advisor: "Kabir Nair", date: iso(1), time: "11:00 AM", stage: "Confirmed", feedback: null },
  { id: "sv2", clientName: "Deepak Menon", clientId: null, propertyId: "p1", advisor: "Kabir Nair", date: iso(-10), time: "4:00 PM", stage: "Completed", feedback: { interest: "High", propertyFit: "Good", locationFit: "Good", budgetFit: "Stretch", nextAction: "Negotiate", notes: "Ready to proceed if price adjusts." } },
  { id: "sv3", clientName: "Rohan Shah", clientId: "c1", propertyId: "p9", advisor: "Isha Rao", date: iso(3), time: "10:30 AM", stage: "Requested", feedback: null },
];

export const followUps = [
  { id: "f1", client: "Rohan Shah", clientId: "c1", propertyId: "p1", advisor: "Isha Rao", date: iso(0), time: "3:00 PM", purpose: "Share curated set", priority: "High", status: "Today", notes: "Walk through perspective." },
  { id: "f2", client: "Priya Nair", clientId: "c2", propertyId: "p7", advisor: "Kabir Nair", date: iso(-1), time: "12:00 PM", purpose: "Post site-visit call", priority: "High", status: "Overdue", notes: "Confirm booking intent." },
  { id: "f3", client: "Vikram Reddy", clientId: null, propertyId: "p5", advisor: "Aarav Menon", date: iso(1), time: "5:00 PM", purpose: "Villa options review", priority: "Medium", status: "Upcoming", notes: "Discuss low-density enclave." },
  { id: "f4", client: "Sneha Kulkarni", clientId: null, propertyId: "p2", advisor: "Isha Rao", date: iso(2), time: "11:00 AM", purpose: "Design walkthrough", priority: "Low", status: "Upcoming", notes: "" },
];

export const enquiries = [
  { id: "e1", name: "Karthik Rao", phone: "+91 98111 22334", email: "karthik@example.com", interest: "Property Consultation", subject: "Investment guidance", message: "Looking for advice on a 2 BHK investment in North Bengaluru.", createdAt: iso(-2), status: "New" },
  { id: "e2", name: "Divya Menon", phone: "+91 99220 33445", email: "divya@example.com", interest: "Luxe", subject: "Villa enquiry", message: "Interested in low-density villas on Kanakapura Road.", createdAt: iso(-6), status: "Contacted" },
];

export const documents = [
  { id: "d1", clientId: "c1", name: "Aster Meridian — Brochure.pdf", type: "Brochure", uploadedAt: iso(-4) },
  { id: "d2", clientId: "c1", name: "Perspective Brief — Whitefield.pdf", type: "Perspective Brief", uploadedAt: iso(-1) },
];

export const activityLog = [
  { id: "a1", date: iso(-1), actor: "Isha Rao", text: "Curated 3 properties for Rohan Shah", type: "curation" },
  { id: "a2", date: iso(-2), actor: "Kabir Nair", text: "Scheduled site visit for Priya Nair", type: "visit" },
  { id: "a3", date: iso(-2), actor: "System", text: "New lead ARC-L-0006 from walk-in", type: "lead" },
  { id: "a4", date: iso(-2), actor: "Aarav Menon", text: "Qualified lead ARC-L-0003", type: "lead" },
];

export function buildInitialData() {
  return {
    properties: JSON.parse(JSON.stringify(properties)),
    leads: JSON.parse(JSON.stringify(leads)),
    clients: JSON.parse(JSON.stringify(clients)),
    interests: JSON.parse(JSON.stringify(interests)),
    siteVisits: JSON.parse(JSON.stringify(siteVisits)),
    followUps: JSON.parse(JSON.stringify(followUps)),
    enquiries: JSON.parse(JSON.stringify(enquiries)),
    documents: JSON.parse(JSON.stringify(documents)),
    team: JSON.parse(JSON.stringify(team)),
    activityLog: JSON.parse(JSON.stringify(activityLog)),
    leadCounter: 8,
  };
}
